<div class="popup-wrapper" (click)="closePopup()">
  <div class="popup-container" (click)="$event.stopPropagation()">
    <u-icon
      (click)="closePopup()"
      class="close-icon"
      [model]="{ type: 'font', value: 'icon-times' }"
      [styles]="{ fontSize: '20px', color: 'var(--color-text-tertiary)' }"
    ></u-icon>
    <span class="popup-title">Advanced instructions</span>
    <div class="popup-textarea">
      <u-textarea
        [styles]="{ maxHeight: '404px', minHeight: '160px' }"
        [maxLength]="popupData()?.maxLength"
        [placeholder]="popupData()?.placeholder || ''"
        [model]="textContent()"
        [autoResize]="true"
        [minHeight]="160"
        [fixedBackgroundColor]="true"
        [disabled]="popupData()?.disabled"
        [displayLimitWarning]="true"
        [ignoreEnter]="true"
        (onChange)="onReasonTextChange($event)"
        #textArea
      ></u-textarea>
    </div>
    <span class="popup-footer">{{ popupData()?.footer }}</span>
    <div class="popup-buttons">
      <u-button [label]="'Close'" type="secondary" (onClick)="closePopup()" [elementSize]="'medium'" [styles]="{ width: '96px' }"></u-button>
    </div>
  </div>
</div>
